import React, { Component } from "react";
// import Status from "./status";

class NotFound extends Component {
  constructor() {
    super();
    this.redirect = true;
    this.redirectToHome = this.redirectToHome.bind(this);
  }
  componentDidMount() {
    this.redirectToHome();
  }
  redirectToHome() {
    const isItHome = window.location.pathname === "/";
    if (!isItHome && this.redirect) {
      window.location.href = window.location.origin;
    }
  }
  render() {
    // return (
    //   <Status code={404}>
    //     <div>
    //       <h1>Sorry, can’t find that.</h1>
    //     </div>
    //   </Status>
    // );
    return <div />;
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/component/routingComponent/NotFound.js